import { Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type, int32_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { TableBody, TableHead, TableRow, Table, TableCell } from "@mui/material";
import { empty, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { comparePrimitives, equals } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1 } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { sortByDescending, map } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { fromUtcToLocalString } from "./Utils.js";
import { createElement } from "react";

export class Target extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["VesselAudits", "RouteAudits", "AdminAudits"];
    }
}

export function Target_$reflection() {
    return union_type("AuditLogs.Target", [], Target, () => [[["Item", int32_type]], [["Item", int32_type]], []]);
}

export function tableView(isMobile, target, audits) {
    let elements_9, children_1, children, elements_8;
    const th$0027 = (x) => MuiHelpers_createElement(TableCell, [["size", "small"], ["children", x]]);
    return MuiHelpers_createElement(Table, [(elements_9 = [(children_1 = singleton_1((children = toList(delay(() => append(singleton(th$0027("Dato")), delay(() => append(toList(delay(() => {
        if (equals(target, new Target(2, []))) {
            return append(singleton(th$0027("Type")), delay(() => singleton(th$0027("Navn"))));
        }
        else {
            return empty();
        }
    })), delay(() => append(singleton(th$0027("Endring")), delay(() => singleton(th$0027("Utført av")))))))))), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), MuiHelpers_createElement(TableBody, [(elements_8 = [map((item) => {
        let elements_5;
        const date = `${fromUtcToLocalString(item.EditDate)}`;
        return MuiHelpers_createElement(TableRow, [(elements_5 = toList(delay(() => append(singleton(MuiHelpers_createElement(TableCell, toList(delay(() => append(singleton(["size", "small"]), delay(() => append(!isMobile ? singleton(["style", {
            whiteSpace: "nowrap",
        }]) : empty(), delay(() => singleton(["children", reactApi.Children.toArray([date])]))))))))), delay(() => {
            let elements_1;
            return append((target.tag === 2) ? append(singleton(MuiHelpers_createElement(TableCell, [["size", "small"], (elements_1 = [createElement("span", {
                children: [(item.EntityType === 1) ? "Fartøy" : ((item.EntityType === 2) ? "Aktivitet" : "Samband")],
            })], ["children", reactApi.Children.toArray(Array.from(elements_1))])])), delay(() => {
                let elements_2;
                return singleton(MuiHelpers_createElement(TableCell, [["size", "small"], (elements_2 = [createElement("span", {
                    children: [item.Entity],
                })], ["children", reactApi.Children.toArray(Array.from(elements_2))])]));
            })) : (empty()), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["size", "small"], ["children", reactApi.Children.toArray([item.ChangesText])]])), delay(() => singleton(MuiHelpers_createElement(TableCell, toList(delay(() => append(singleton(["size", "small"]), delay(() => append(!isMobile ? singleton(["style", {
                whiteSpace: "nowrap",
            }]) : empty(), delay(() => {
                let elements_4, matchValue_1;
                return singleton((elements_4 = [(matchValue_1 = item.Editor, (matchValue_1 != null) ? matchValue_1.Name : "Synkroniseringstjeneste")], ["children", reactApi.Children.toArray(Array.from(elements_4))]));
            }))))))))))));
        })))), ["children", reactApi.Children.toArray(Array.from(elements_5))])]);
    }, sortByDescending((ev) => ev.EditDate, audits, {
        Compare: comparePrimitives,
    }))], ["children", reactApi.Children.toArray(Array.from(elements_8))])])], ["children", reactApi.Children.toArray(Array.from(elements_9))])]);
}

//# sourceMappingURL=AuditLogs.js.map
